import { useEffect } from "react";
import usePlaylistStore from "../store/playlistStore";
import SleepTrackItem from "./tracks/SleepTrackItem";
import { useSkeletonHandler } from "../hooks/useSkeletonHandler";
import CardListSkeleton from "./skeletonUI/CardListSkeleton";

import type { SleepSpotifyTrack } from "../types/tracksType";
import useSleepTracks from "../hooks/useSleepTracks";
import { getFetchedContentFadeAnimation } from "../lib/fetchedContentFadeAnimation";

const SleepTracks = () => {
  const tracks = usePlaylistStore((state) => state.tracks);
  const { fetchSleepTracks, isSleepTracksFetching, isSleepTracksFromCache, restoreSleepTrack, restoringTrackId } = useSleepTracks();
  const isEmptySleepTracks = !isSleepTracksFetching && tracks !== null && tracks.length === 0;
  const showSkeleton = useSkeletonHandler({ isDataLoading: isSleepTracksFetching, skipSkeleton: isSleepTracksFromCache });

  useEffect(() => {
    fetchSleepTracks();
  }, []);

  return (
    <div className="sleep">
      <h1 className="sleep__title">スリープ曲一覧</h1>
      <p className="sleep__text">一時的に非表示にしている曲</p>

      <div className="empty-message-wrapper">
        <p className={` fade-on-loaded ${showSkeleton || !isEmptySleepTracks ? "" : "fade-in-up"}`}>スリープ中の曲はありません</p>
      </div>

      {showSkeleton && <CardListSkeleton />}

      <ul className={`sleep__track-list fade-on-loaded ${getFetchedContentFadeAnimation(showSkeleton, isSleepTracksFromCache)}`}>
        {(tracks as SleepSpotifyTrack[]).map((track, index) => {
          const addedAt = track.addedAt;
          const date: string | Date = new Date(addedAt ?? 0).toLocaleString();

          return (
            <SleepTrackItem
              key={track.id}
              track={track}
              index={index}
              date={date}
              restoreSleepTrack={restoreSleepTrack}
              restoringTrackId={restoringTrackId}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default SleepTracks;
